import { Fragment, createElement, useMemo } from 'react';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import rehypeSanitize from 'rehype-sanitize';
import { unified } from 'unified';
import { getSearchHighlightContext } from './getSearchHighlightContext';
import { Mark } from './styled';
const processor = unified()
    .use(rehypeParse, { fragment: true })
    .use(rehypeSanitize, { tagNames: ['mark'] })
    .use(rehypeReact, { Fragment, createElement, components: { mark: Mark } })
    .freeze();
/**
 * Safely renders HTML text from search results with highlighted matches.
 *
 * @example
 * // Input: '<mark>contract</mark> management <script>alert("xss")</script>'
 * // Output: Renders "<mark>contract</mark> management" with "contract" highlighted (script removed)
 */
export function useSafeSearchResultText(props) {
    const { name, highlight } = props;
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    const result = useMemo(() => processor.processSync(highlightText).result, [highlightText]);
    return {
        showNameOnly,
        result,
    };
}
